var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviousButtoninline = function SvgPreviousButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2 9.621 13.148 8.246c.469.294.849.086.849-.466V.59c0-.552-.386-.756-.85-.466L2 8.371V.993A.994.994 0 0 0 1 0C.448 0 0 .445 0 .993v16.006c0 .549.444.993 1 .993.552 0 1-.445 1-.993V9.621z"
  })));
};
export default SvgPreviousButtoninline;